import React, { useState } from 'react';
import './ContactForm.scss';
import { useTranslation } from 'react-i18next';
import getServicesData from '../../sections/Services/ServiceData';

const ContactForm = () => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        service: '',
        message: '',
        privacyConsent: false
    });
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState(null);

    const servicesData = getServicesData(t);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setResponse(null);

        try {
            const formDataToSend = new FormData();
            formDataToSend.append('name', formData.name);
            formDataToSend.append('email', formData.email);
            formDataToSend.append('message', formData.message);
            if (formData.service) formDataToSend.append('service', formData.service);
            formDataToSend.append('privacyConsent', formData.privacyConsent ? '1' : '0');

            const handlerUrl = window.location.origin + '/form-handler.php';
            const response = await fetch(handlerUrl, {
                method: 'POST',
                body: formDataToSend,
                mode: 'same-origin',
                credentials: 'same-origin'
            });

            const data = await response.json();
            setResponse(data);

            if (data.success) {
                // Reset form
                setFormData({
                    name: '',
                    email: '',
                    service: '',
                    message: '',
                    privacyConsent: false
                });
            }
        } catch (error) {
            setResponse({
                success: false,
                message: t('contactForm.networkError') || 'Netzwerkfehler. Bitte versuchen Sie es später erneut.'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="contact-form-wrapper">
            {response && (
                <div className={`form-alert ${response.success ? 'alert-success' : 'alert-error'}`}>
                    {response.message}
                    {response.errors && Object.keys(response.errors).length > 0 && (
                        <ul className="form-errors">
                            {Object.entries(response.errors).map(([field, error]) => (
                                <li key={field}>{error}</li>
                            ))}
                        </ul>
                    )}
                </div>
            )}

            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="form-group">
                            <label>{t('contactForm.name')} *</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                placeholder={t('contactForm.namePlaceholder')}
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="form-group">
                            <label>{t('contactForm.email')} *</label>
                            <input 
                                type="email" 
                                className="form-control" 
                                placeholder={t('contactForm.emailPlaceholder')}
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-group">
                            <label>{t('contactForm.service')}</label>
                            <select 
                                className="form-control"
                                name="service"
                                value={formData.service}
                                onChange={handleChange}
                            >
                                <option value="">{t('contactForm.selectService') || 'Bitte wählen'}</option>
                                {servicesData.map((service, index) => (
                                    <option key={index} value={service.title}>{service.title}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="form-group">
                            <label>{t('contactForm.messages')} *</label>
                            <textarea 
                                className="form-control" 
                                placeholder={t('contactForm.messagesPlaceholder')} 
                                rows="5"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                            ></textarea>
                        </div>
                    </div>

                    <div className="col-lg-12">
                        <div className="form-group privacy-consent-group">
                            <label className="privacy-checkbox-label">
                                <input 
                                    type="checkbox" 
                                    name="privacyConsent"
                                    checked={formData.privacyConsent}
                                    onChange={handleChange}
                                    required
                                    className="privacy-checkbox"
                                />
                                <span className="privacy-checkbox-text">
                                    {t('contactForm.privacyConsentText')}
                                    <a href="/datenschutz" target="_blank" rel="noopener noreferrer" className="privacy-link">
                                        {t('contactForm.privacyPolicy')}
                                    </a>
                                    {t('contactForm.privacyConsentTextEnd')}
                                </span>
                            </label>
                        </div>
                    </div>

                    <div className="col-lg-12">
                        <button 
                            type="submit" 
                            className="btn appointment-btn"
                            disabled={loading || !formData.privacyConsent}
                        >
                            {loading ? (t('contactForm.sending') || 'Wird gesendet...') : t('contactForm.bookAppointment')}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default ContactForm;
